const EmergencyImportMode = {
    BY_PARTICIPANT_ID: "BY_PARTICIPANT_ID",
    BY_PARTICIPANT_NAME: "BY_PARTICIPANT_NAME",
};

const formatEmergencyImportMode = (value) => {
    switch (value) {
        case EmergencyImportMode.BY_PARTICIPANT_ID:
            return "Nach Teilnehmer-ID";
        case EmergencyImportMode.BY_PARTICIPANT_NAME:
            return "Nach Teilnehmername";
        default:
            return "";
    }
};

export { EmergencyImportMode, formatEmergencyImportMode };